export {SearchHeaderConnected as SearchHeader} from './SearchHeader.connect';
